import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

// Get project image from latest report or fallback
const getProjectImage = (project) => {
  if (project?.preview_image) {
    return project.preview_image;
  }

  return (
    project?.location_image ||
    project?.locationImage ||
    project?.image ||
    project?.thumbnail ||
    "/assets/images/default.jpeg"
  );
};

// Get status badge text and class
const getStatusInfo = (titlesTranslation, project) => {
  if (project?.completed) {
    return { text: titlesTranslation, className: "map-tooltip__badge--completed" };
  }
  if (project?.report_in_process) {
    return {
      text: project.report_in_process,
      className: "map-tooltip__badge--active",
    };
  }
  return null;
};

const MapTooltip = ({
  selectedProject,
  mapInstance,
  getProjectPosition,
  setImagePreview,
  translations,
  setSelectedProjectId,
  user,
  setDeletingProject,
  setShowDeleteModal,
  isInsideCluster = false,
}) => {
  const location = useLocation();
  const navigate = useNavigate();

  if (!selectedProject) return null;

  const completedLabel = translations?.["titles.completed"] ?? "Completed";
  const statusInfo = getStatusInfo(completedLabel, selectedProject);

  const handleClick = (project) => {
    if (mapInstance) {
      const pos = getProjectPosition(project);
      if (pos) {
        mapInstance.setCenter(pos);
        mapInstance.setZoom(12);
        setSelectedProjectId(project.id);
      }
    }
  };
  return (
    <div className="map-tooltip" onClick={()=>handleClick(selectedProject)}>
      <div className="map-tooltip__header">
        <img src="/assets/icons/location.svg" alt="" />
        <p className="map-tooltip__address"
           title={selectedProject?.contract_location || ""}
            >
         <span className="map-tooltip__title-text">
            {selectedProject?.contract_location || ""}
         </span>
        </p>
      </div>
      <div className="map-tooltip__content">
        <div className="map-tooltip__image-wrapper">
          <img
            src={getProjectImage(selectedProject)}
            alt={selectedProject?.project_name || "Project"}
            className="map-tooltip__image"
            onClick={() => setImagePreview(getProjectImage(selectedProject))}
          />
        </div>
        <div className="map-tooltip__body">
          <h3
            className="map-tooltip__title"
            title={selectedProject?.project_name || ""}
          >
            <span className="map-tooltip__title-text">
              {selectedProject?.project_name || ""}
            </span>
          </h3>
          <div className="map-tooltip__footer">
            <div className="map-tooltip__meta">
              {statusInfo && (
                <span className={`map-tooltip__badge ${statusInfo.className}`}>
                  {statusInfo.text}
                </span>
              )}
            </div>
            <div className="map-tooltip__actions dashboard__editBtns">
                <div
                  state={{ project: selectedProject }}
                  className={`${selectedProject?.actions?.charts?.dashboard_id ? 'map-tooltip__actions__editBtn' : ''}`}
                  onMouseEnter={() => {
                    localStorage.setItem("itemId", selectedProject.id);
                    // When inside cluster list, don't switch to single-project view so the list stays visible
                    if (!isInsideCluster) {
                      setSelectedProjectId(selectedProject.id);
                    }
                  }}
                >
                  <img src="/assets/icons/dashboardview.svg" alt="" />
                  <div
                    className="map-tooltip__actions-links"
                    onMouseLeave={() => {
                      // setCurrentItem(null)
                    }}
                  >
                    {selectedProject?.actions?.charts?.dashboard_id ? (
                      <Link
                        tag
                        to={`/dashboard/${selectedProject?.id}`}
                        state={{
                          project: selectedProject,
                          dash_visible:
                            selectedProject?.actions?.charts?.dashboard_id,
                          larp_visible:
                            selectedProject?.actions?.charts?.larp_id,
                        }}
                        onClick={() =>
                          localStorage.setItem("itemId", selectedProject.id)
                        }
                      >
                        {translations?.["actions.project_dashboard"]}
                      </Link>
                    ) : null}
                    {selectedProject?.actions?.charts?.larp_id ? (
                      <Link
                        to={`/larp-dashboard/${selectedProject?.id}`}
                        state={{
                          project: selectedProject,
                          dash_visible:
                            selectedProject?.actions?.charts?.dashboard_id,
                          larp_visible:
                            selectedProject?.actions?.charts?.larp_id,
                        }}
                        onClick={() =>
                          localStorage.setItem("itemId", selectedProject.id)
                        }
                      >
                        {translations?.["actions.view_larp_dashboard"]}
                      </Link>
                    ) : null}
                  </div>
                </div>
              <div
                className="map-tooltip__actions__editBtn"
                onClick={() => {
                  if (!selectedProject?.actions?.view_id) return;
                  localStorage.setItem("itemId", String(selectedProject?.id));
                  const returnPath = `${location.pathname}${location.search || ""}`;
                  navigate(
                    `/online-view/${selectedProject?.actions?.view_id}`,
                    {
                      state: {
                        id: selectedProject?.latest_report?.id,
                        prevLocation: returnPath,
                        date: selectedProject?.latest_report?.date,
                      },
                    },
                  );
                }}
              >
                <img src="/assets/icons/eyelist.svg" alt="" />
                <p>{translations?.["actions.view_report"]}</p>
              </div>

              {user?.permissions?.edit_project && (
                <Link
                  to={`/project/${selectedProject?.id}`}
                  state={{ project: selectedProject }}
                  className="map-tooltip__actions__editBtn"
                  onClick={() =>
                    localStorage.setItem("itemId", String(selectedProject?.id))
                  }
                >
                  <img src="/assets/icons/edit-report.svg" alt="" />
                  <p>{translations?.["actions.edit_report"]}</p>
                </Link>
              )}
              {user?.permissions?.delete_project && (
                <div
                  className="map-tooltip__actions__editBtn delete"
                  onClick={() => {
                    setDeletingProject(selectedProject);
                    setShowDeleteModal(true);
                  }}
                >
                  <div className="dashboard__deleteBtn">
                    <img
                      color="red"
                      src="/assets/icons/trash-grey.svg"
                      alt="Delete project"
                    />
                  </div>
                  <p>{translations?.["actions.delete_project"]}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MapTooltip;
